import * as api from "../generated-api";
import { apiCall } from "../common";

export const getDealCompanyMembers = (
  orgId: number,
  dealId: number,
  successCallback?: (dealCompanyMembers: api.DealLegalEntity[]) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLegalEntity[]>(
    () => {
      return api.getDealCompanyMembers(orgId, dealId);
    },
    successCallback,
    errorCallback
  );
};

export const addNewPersonAsDealCompanyMember = async (
  orgId: number,
  dealId: number,
  member: api.LegalEntityAndPersonCreate,
  successCallback?: (dealCompanyMember: api.DealLegalEntity) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLegalEntity>(
    () => {
      return api.addNewPersonAsDealCompanyMember(orgId, dealId, member);
    },
    successCallback,
    errorCallback
  );
};

export const addExistingPersonAsDealCompanyMember = async (
  orgId: number,
  dealId: number,
  personWithPosition: api.AddPersonAsLegalEntity,
  successCallback?: (dealCompanyMember: api.DealLegalEntity) => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<api.DealLegalEntity>(
    () => {
      return api.addExistingPersonAsDealCompanyMember(
        orgId,
        dealId,
        personWithPosition
      );
    },
    successCallback,
    errorCallback
  );
};

export const removeDealCompanyMember = async (
  orgId: number,
  dealId: number,
  dealCompanyMemberId: number,
  successCallback?: () => void,
  errorCallback?: (error: Error) => void
) => {
  apiCall<undefined>(
    () => {
      return api.removeDealCompanyMember(orgId, dealId, dealCompanyMemberId);
    },
    successCallback,
    errorCallback
  );
};
